import React, { useEffect, useState } from 'react'

const ExpandedComponent = ({ data }) => {

    // const [localState, setLocalState] = useState({ book_items: [] });
    const [items, setItems] = useState([]);

    // useEffect(() => {
    //     // Handle updates to local state based on props
    //     setLocalState({ book_items: data.book_items });
    // }, [data]); // De

    useEffect(() => {

        let bookItemsString = JSON.stringify(data.book_items);
        let bookItems = JSON.parse(bookItemsString);

        let itemArray = [];
        // console.log(bookItems.filter())
        console.log(itemArray)
        setItems(JSON.parse(bookItems));
    }, [data.book_items]);
    return (
        <div id={data.id} className='bg-light px-5 py-2 customer_appoint_services'>
            <div className='d-flex px-3 pe-5 justify-content-between'><div className='py-2 w-25 fw-bold'>Service</div><div className='py-2 w-25  fw-bold'>Price</div> <div className='py-2 w-25  fw-bold'>Duration</div></div>
            {items.map((item) => {
                return (<div className='d-flex px-3 pe-5 justify-content-between' key={item.id}><div className='py-2 w-25'>{item.name}</div><div className='py-2 w-25 '>{item.price}</div> <div className='py-2 w-25 '>{`${Math.floor(item.duration / 60)} H : ${item.duration % 60} Min `}</div></div>)
            })}
        </div>
    )
}



export default ExpandedComponent
